import { render, staticRenderFns } from "./Profitable.vue?vue&type=template&id=156963a2&scoped=true"
import script from "./Profitable.vue?vue&type=script&lang=js"
export * from "./Profitable.vue?vue&type=script&lang=js"
import style0 from "./Profitable.vue?vue&type=style&index=0&id=156963a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156963a2",
  null
  
)

export default component.exports